const DATE_PARTS_RE = /^(\d{1,2})\/(\d{1,2})\/(\d{2,4})$/;

// Backend emits entry/completion as dd/MM/yy (day-first, zero-padded, 2-digit year).
export function parseWfDate(value: string | null | undefined): Date | null {
  if (!value) return null;
  const match = DATE_PARTS_RE.exec(value.trim());
  if (!match) return null;
  const day = Number(match[1]);
  const month = Number(match[2]);
  let year = Number(match[3]);
  if (year < 100) year += 2000;
  if (month < 1 || month > 12 || day < 1 || day > 31) return null;
  const date = new Date(year, month - 1, day);
  if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
  return date;
}

// null when entry or completion is missing/unparseable — caller must exclude from age stats rather than treat as 0.
export function daysBetween(entry: string, completion: string): number | null {
  const entryDate = parseWfDate(entry);
  const completionDate = parseWfDate(completion);
  if (!entryDate || !completionDate) return null;
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  return Math.round((completionDate.getTime() - entryDate.getTime()) / MS_PER_DAY);
}
